import { useState } from "react";
import MainLayout from "../sidebar/Sidebar.js";
import { Pencil, Save, X } from "lucide-react";

export default function Profile() {
  const [location, setLocation] = useState("Profile");
  const [isEditing, setIsEditing] = useState(false);

  // Profile data state
  const [name, setName] = useState("Kody Hatcher");
  const [email, setEmail] = useState("kodyhatcher@gmail.com");
  const [bio, setBio] = useState("Programming ain't easy");

  // State to store original values for cancellation
  const [backup, setBackup] = useState({ name, email, bio });

  const cancel = () => {
    setName(backup.name);
    setEmail(backup.email);
    setBio(backup.bio);
    setIsEditing(false);
  };

  const save = () => {
    // In a real application, you would send this data to your backend
    console.log("Saved:", { name, email, bio });
    setBackup({ name, email, bio }); // Update backup after successful save
    setIsEditing(false);
  };

  return (
    <MainLayout location={location} setLocation={setLocation}>
      <div className="min-h-full py-4 px-6">
        <div className="w-full max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-10 space-y-8 border border-gray-200">
          {/* Header */}
          <div className="pb-6 border-b border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-2">
              Your Profile
            </h1>
            <p className="text-gray-600 text-lg">
              Manage your personal information and preferences.
            </p>
          </div>

          {/* Profile Picture Section */}
          <div className="flex flex-col items-center gap-4">
            <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-blue-500 shadow-md flex items-center justify-center bg-gray-100">
              {/* Using a placeholder SVG for the avatar */}
              <img
                src="/Scooter.jpeg"
                alt="User Avatar"
                className="w-full h-full object-cover"
              />
            </div>
            {isEditing && (
              <button className="text-base text-blue-600 hover:underline font-medium transition-colors duration-200">
                Change Photo
              </button>
            )}
          </div>

          {/* Info Fields */}
          <div className="grid gap-6">
            {[
              { label: "Name", value: name, set: setName, type: "text" },
              { label: "Email", value: email, set: setEmail, type: "email" },
              { label: "About", value: bio, set: setBio, type: "textarea" },
            ].map(({ label, value, set, type }) => (
              <div key={label} className="grid gap-2">
                <label className="block text-sm font-semibold text-gray-700">
                  {label}
                </label>
                {isEditing ? (
                  type === "textarea" ? (
                    <textarea
                      value={value}
                      onChange={(e) => set(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 min-h-[100px]"
                    />
                  ) : (
                    <input
                      type={type}
                      value={value}
                      onChange={(e) => set(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    />
                  )
                ) : (
                  <p className="text-base text-gray-800 bg-gray-50 p-3 rounded-md border border-gray-100 whitespace-pre-wrap">
                    {value}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            {isEditing ? (
              <>
                <button
                  onClick={cancel}
                  className="flex items-center gap-2 px-5 py-2 border border-gray-300 rounded-md text-base text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-all duration-200"
                >
                  <X className="h-4 w-4" /> Cancel
                </button>
                <button
                  onClick={save}
                  className="flex items-center gap-2 px-5 py-2 bg-blue-600 text-white rounded-md text-base hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
                >
                  <Save className="h-4 w-4" /> Save
                </button>
              </>
            ) : (
              <button
                onClick={() => setIsEditing(true)}
                className="flex items-center gap-2 px-5 py-2 bg-blue-600 text-white rounded-md text-base hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
              >
                <Pencil className="h-4 w-4" /> Edit Profile
              </button>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
